console.clear();
console.log("\n%c Spaceships version 5.0.0", "color:#fff;font-size:12px; padding:0.45rem 0.75rem; margin: 0rem auto 1rem auto; font-family: Metropolis, Helvetica, sans-serif; border: 2px solid #0dd8d8; border-radius: 4px;font-weight: 100;background-size: cover;background-repeat: no-repeat;border: double 1px transparent;background-image: linear-gradient(#282828, #282828), radial-gradient(circle at top left, #DF542F, #F2BAAB);background-origin: border-box;background-clip: padding-box, border-box;")


/*------------------------------------------------------------------
Import styles
------------------------------------------------------------------*/

import './../styles/style.scss';


/*------------------------------------------------------------------
Error reporting
------------------------------------------------------------------*/

import * as log from './components/sentry';
import * as error from './components/errors';


/*------------------------------------------------------------------
External
------------------------------------------------------------------*/

import $ from 'cash-dom';
import Swal from 'sweetalert2/src/sweetalert2.js';

/*------------------------------------------------------------------
Debugging the DOM
------------------------------------------------------------------*/

window.$ = $;


/*------------------------------------------------------------------
Internal
------------------------------------------------------------------*/

import './components/tooltips.js';
import * as portal from './components/portal.js';
import * as api from './components/api';
import * as templates from './components/templates';


/*------------------------------------------------------------------
Booking page
------------------------------------------------------------------*/

// Contextually load needed JS requirements
document.addEventListener('DOMContentLoaded', () => {
    if (window.pageType && window.pageType === 'book') import('./components/booking');
    if (window.pageType && window.pageType === 'agent') import('./components/agent');
});



/**
 * Search for a booking from RCM
 * @param {string} reservation_number 
 * @param {string} last_name 
 */
const searchForBooking = (reservation_number, last_name) => {

    // Show the vehicle loader 
    $('body').addClass('loading');

    // We need to perform a search then perform a fetch as this is RCM andy they require 2 API calls 
    // to get the booking information obviously.
    api.find_booking_post({ reservation_number, last_name })
        .then(json => {

            // If we get back a valid booking, we can then fech the booking
            if (json.error === '' && json.results[0] && json.results[0].reservationref) {


                if (window.pageType === 'checkin-portal') {

                    // Fetch the booking from the RCM API
                    api.fetch_workflow_checklist({ reservation_reference: json.results[0].reservationref })
                        .then(json => {

                            // If there is an error show the correct booking search form again
                            // otherwise we can populate the checkin portal page
                            (json.error === '') ? populateCheckinPage(json.results) : showBookingSearchForm(false, json.error);

                        }).catch(error => {

                            // Show the error
                            console.error(error);

                            // Log any errors discretely
                            log.error('API catch: fetch_workflow_checklist', error);

                            // If there is an error show the booking search form
                            showBookingSearchForm(false);
                        });

                } else {
                    // Fetch the booking from the RCM API
                    api.fetch_booking_post({ reservation_reference: json.results[0].reservationref })
                        .then(json => {

                            // If there is an error show the correct booking search form again
                            // otherwise we can populate the payment page
                            (json.error === '') ? (window.pageType === 'quote') ? populateQuoteToBookingPage(json.results) : populatePaymentPage(json.results) : showBookingSearchForm(false, json.error);

                        }).catch(error => {

                            // Show the error
                            console.error(error);

                            // Log any errors discretely
                            log.error('API catch: fetch_booking_post', error);

                            // If there is an error show the booking search form
                            showBookingSearchForm(false);
                        });
                }
            } else {
                showBookingSearchForm(false, json.error);
            }

        }).catch(error => {
            // Show the error
            console.error(error);

            // Log any errors discretely
            log.error('API catch: find_booking_post', error);

            // If there is an error show the booking search form
            showBookingSearchForm(false);
        });
};


/**
 * Show the booking search form for use with the payment portal
 * @param {boolean} firstAttempt if this is the first attempt to show the original form
 */
const showBookingSearchForm = (firstAttempt = true, errorMessage) => {
    console.log('showBookingSearchForm')

    // Instantiate our default error message
    let prettyError = {
        icon: '',
        title: templates.swalEnterBookingTitle(),
        message: templates.swalEnterBookingDetails()
    };

    // Let's attempt overide the error message isf there is one
    if (errorMessage) {

        // Override the error message if an alternative exists
        let overiddenError = error.getErrorOverride(errorMessage);

        // Update our error message
        prettyError = {
            icon: overiddenError.icon,
            title: overiddenError.title,
            message: overiddenError.message
        };
    }

    // Hide the vehicle loader
    $('body').removeClass('loading');

    // Show the booking search form with different messages based on the attempt
    Swal.fire({
        allowEscapeKey: false,
        allowOutsideClick: false,
        confirmButtonText: 'SUBMIT',
        icon: (firstAttempt) ? '' : prettyError.icon,
        title: (firstAttempt) ? templates.swalEnterBookingTitle() : prettyError.title,
        html: (firstAttempt) ? templates.swalEnterBookingDetails() : prettyError.message + templates.swalEnterBookingDetailsFail(),
        preConfirm: () => {
            let reservation_number = $('.js-reservation-number').val();
            let last_name = $('.js-last-name').val();
            searchForBooking(reservation_number, last_name);
        }
    });
};


/**
 * Checks to see if a booking is valid based on the RCM api response
 * as well as what page type the user is currently on. If the booking
 * is not valid it will log out the error in the console.
 * @param {object} results 
 * @returns 
 */
const checkIfValidBooking = (results) => {

    // Simplifying RCM's variables
    let due = results.bookinginfo[0].balancedue;
    let cost = results.bookinginfo[0].totalcost;
    let status = results.bookinginfo[0].reservationstatus;
    let is_quotation = results.bookinginfo[0].isquotation;
    let is_valid_quotation = results.bookinginfo[0].isvalidquotation;
    let type_description = results.bookinginfo[0].reservationtypedescription;
    let quote_conversion_valid_message = results.bookinginfo[0].quoteconversionvalidmessage;

    // Create a URL object from the current window's URL
    const url = new URL(window.location.href);

    // Use URLSearchParams to check for the 'country' parameter
    const urlHasCountry = url.searchParams.has('country');


    // If the booking has 0 cost it has probably been cancelled
    if (window.pageType !== 'checkin-portal' && cost === 0) {
        console.log(`%c There is no cost: ${cost}`, 'color: #fb5970');
        return 'There is no cost associated to this booking';
    }

    // PAYMENT PAGE TYPE CHECK
    // If the booking has the wrong reservation status associated to it
    else if (window.pageType === 'payment' && status !== 'Reservation' && status !== 'Hired' && status !== 'Returned' || window.pageType === 'payment' && type_description === 'Online Quotation') {
        console.log(`%c Wrong reservation status for a payment: ${status}`, 'color: #fb5970');
        return 'This booking has the wrong reservation status associated to it';
    }

    // QUOTE TO BOOKING PAGE TYPE CHECK 
    // If the booking has the wrong reservation status associated to it 
    else if (window.pageType === 'quote' && status !== 'Quotation' && is_quotation !== true && is_valid_quotation !== true) {
        console.log(`%c Wrong reservation status for a quote: ${status}`, 'color: #fb5970');
        return 'This quote has the wrong reservation status associated to it';
    }

    // QUOTE TO BOOKING PAGE TYPE CHECK
    // If the booking contains part of an error mnessage
    else if (window.pageType === 'quote' && quote_conversion_valid_message.toLowerCase().indexOf('no longer available') > 0) {
        console.log(`%c Invalid quote: ${quote_conversion_valid_message}`, 'color: #fb5970');
        return quote_conversion_valid_message;
    }

    // CHECK-IN PORTAL PAGE TYPE CHECK
    // If the booking contains part of an error message
    else if (window.pageType === 'checkin-portal' && status !== 'Reservation') {
        console.log(`%c Invalid check-in booking: `, 'color: #fb5970');
        return 'This is not a valid booking for the check-in portal';
    }

    // If the user has paid more than the overall cost or there is no balance due and they are not on the checkin portal
    else if (window.pageType !== 'checkin-portal' && due <= 0 && !urlHasCountry) {
        console.log(`%c There is a negative amount due: ${due}`, 'color: #fb5970');
        return 'It looks like there is no remaining balance to be paid on this booking.';
    }

    // If no other errors are found the booking is valid
    else {
        console.log(`%c Proceed with booking`, 'color: #60ab61');
        return true;
    }
};


const populateCheckinPage = (data) => {

    // Hide the vehicle loader
    $('body').removeClass('loading');

    // Check to see if the user is able to proceed with this booking
    if (checkIfValidBooking(data) !== true) {

        // Present user with an error modal
        showBookingSearchForm(false, checkIfValidBooking(data));

    } else {

        window.portal_data = data;

        portal.populateDriverTab();
        portal.populateAddonTab();
        portal.populatePaymentsTab();
        portal.populateSignaturesTab();
        portal.populateLicenseTab();

        $('.js-save-details').trigger('click');
    }

};

/**
 * Populate the users bokking information on the payment portal
 * using the response from the RCM api
 * @param {collection} data 
 */
const populatePaymentPage = (data) => {

    // Hide the vehicle loader
    $('body').removeClass('loading');

    // Check to see if the user is able to proceed with this booking
    if (checkIfValidBooking(data) !== true) {

        // Present user with an error modal
        showBookingSearchForm(false, checkIfValidBooking(data));

    } else {

        // Simplifying RCM's variables
        let booking = data.bookinginfo[0];
        let customer = data.customerinfo[0];

        window.reservation_reference = booking.reservationref;

        // Populate the dynamic fields on the payment portal
        $('.js-first-name').html(customer.firstname);
        $('.js-payment-dates').html(templates.paymentDates(data));
        $('.js-payment-details').html(templates.paymentDetails(data));

        // Pre-fill the payment form with the remaining amount
        $('.js-amount-due').val(parseFloat(booking.balancedue).toFixed(2));
        $('.js-ref-id').val(booking.reservationref);
        $('.js-currency-name').val(booking.currencyname);
        $('.js-currency-symbol').val(booking.currencysymbol);

        // Add in the imagery for the vehicle
        $('.js-payment-image').html(templates.paymentThumbnail(booking.vehiclecategoryid));

        // Fill in any shortcodes that may be present
        $('.js-shortcode-firstname').html(customer.firstname);
        $('.js-shortcode-lastname').html(customer.lastname);
        $('.js-shortcode-email').html(customer.email);
    }


};


/**
 * Only allow users to enter numbers and decimal points in the amount due field
 */
$('body').on('keydown', '.js-amount-due', (e) => {
    if (e.shiftKey == true) {
        e.preventDefault();
    }

    if ((e.keyCode >= 48 && e.keyCode <= 57) ||
        (e.keyCode >= 96 && e.keyCode <= 105) ||
        e.keyCode == 8 || e.keyCode == 9 || e.keyCode == 37 ||
        e.keyCode == 110 || e.keyCode == 39 || e.keyCode == 46 || e.keyCode == 190) {
    } else {
        e.preventDefault();
    }

});


/*------------------------------------------------------------------

                        PAYMENT PORTAL PAGE 

This is the entry point for the payment portal that customers to be 
able to pay of all or parts of their booking. They can also add in 
new cards once their booking is underway. To be able to proceed a 
booking needs to be under way and there needs to be an amount to 
pay or the risk of a refund would present itself.
------------------------------------------------------------------*/

$(() => {

    // Find the reservation reference from the URL if there is one
    let url = new URL(window.location.href);
    let reservation_reference = url.searchParams.get('refID');
    let selected_country = url.searchParams.get('country');
    let $paymentPortal = $('.js-payment-portal');

    // Fetch a booking depending on if there is a URL parameter or not
    if ($paymentPortal.length && reservation_reference) {

        // Show the vehicle loader
        $('body').addClass('loading');

        // Fetch the booking from the RCM API
        api.fetch_booking_post({ reservation_reference })
            .then(json => {
                (json.error === '') ? populatePaymentPage(json.results) : showBookingSearchForm(false, json.error);
            }).catch(error => {
                // Show the error
                console.error(error);

                // Log any errors discretely
                log.error('API catch: find_booking_post', error);

                // If there is an error show the booking search form
                showBookingSearchForm(false);
            });
    }

    else if (selected_country) {

        // Show the vehicle loader
        $('body').addClass('loading');

        // Fetch the booking from the RCM API
        api.fetch_booking_post_agent({ reservation_reference, selected_country })
            .then(json => {
                (json.error === '') ? populatePaymentPage(json.results) : showBookingSearchForm(false, json.error);
            }).catch(error => {
                // Show the error
                console.error(error);

                // Log any errors discretely
                log.error('API catch: find_booking_post', error);

                // If there is an error show the booking search form
                showBookingSearchForm(false);
            });
    }

    // If no URL parameter is present, show the booking search form
    else if ($paymentPortal.length) {
        showBookingSearchForm();
    }

    // User interactions on clicking the payment portal payment button
    $('body').on('click', '.js-make-payment', (e) => {
        // Add a loading class to the button
        $(e.currentTarget).addClass('busy');
    });

    // User interactions on the Swal popup
    $('body').on('keyup', '.js-last-name,.js-reservation-number', (e) => {
        // If a user hits the enter key, let's submit the form
        if (e.keyCode === 13) $('.swal2-confirm').trigger('click');
    });

});


/**
 * Populate the users bokking information on the payment portal
 * using the response from the RCM api
 * @param {collection} data 
 */
const populateQuoteToBookingPage = (data) => {

    // Hide the vehicle loader
    $('body').removeClass('loading');

    // Check to see if the user is able to proceed with this booking
    if (checkIfValidBooking(data) !== true) {

        // Present user with an error modal
        showBookingSearchForm(false, checkIfValidBooking(data));

    } else {
        // Shorten our variable names
        let booking = data.bookinginfo[0];
        let customer = data.customerinfo[0];

        // Specific test to see if a booking was created by an agent
        let isAgentBooking = (booking.agent && booking.agent !== '') ? true : false;

        // Log out info if this is an agent booking
        if (isAgentBooking) console.log(`%c Agent booking present`, 'color: #f05a29');

        // Set the reservation reference
        window.reservation_reference = booking.reservationref;

        // Populate the dynamic fields on the payment portal
        $('.js-first-name').html(customer.firstname);
        $('.js-last-name').html(customer.lastname);
        $('.js-payment-dates').html(templates.paymentDates(data));
        $('.js-payment-details').html(templates.paymentDetails(data, isAgentBooking));

        // Fill in any shortcodes that may be present
        $('.js-shortcode-firstname').html(customer.firstname);
        $('.js-shortcode-lastname').html(customer.lastname);
        $('.js-shortcode-email').html(customer.email);

        // Pre-fill the amount spans with their appropriate values
        $('.js-full-amount').html(`${window.currency_symbol}${parseFloat(booking.totalcost).toFixed(2)}`);
        $('.js-deposit-amount').html(`${window.currency_symbol}${parseFloat(0.2 * booking.totalcost).toFixed(2)}`);
        $('.js-remaining-amount').html(`${window.currency_symbol}${parseFloat(0.8 * booking.totalcost).toFixed(2)}`);

        // Pre-fill any existing payment details from the booking
        $('.js-first-name-input').val(customer.firstname);
        $('.js-last-name-input').val(customer.lastname);
        $('.js-email-input').val(customer.email);
        $('.js-remarks-input').val(customer.customerremark);

        // Prefill the agents email address
        if (isAgentBooking) $('.js-agent-email-input').val(booking.agentemail);

        // Remove required fields from agent only bookings
        if (!isAgentBooking) $('.js-agent-email-input').removeAttr('required');
        if (!isAgentBooking) $('.js-agent-code').removeAttr('required');

        // Pre-fill the payment form with the remaining amount
        $('.js-ref-id').val(booking.reservationref);

        // Update the selected vehicle name        
        $('.js-vehicle-name').text(booking.vehiclecategory);

        // Add in the imagery for the vehicle
        $('.js-payment-image').html(templates.paymentThumbnail(booking.vehiclecategoryid));

        if (booking.isonrequest) {
            $('.js-show-for-booking-request').show();
            $('.specialRadio').hide();
            $('#payment-amount-deposit-booking-request').prop('checked', true);
            $('#payment-amount-deposit-booking-request').parent().show();
        }

        // Minor changes needed if an agent booking
        if (isAgentBooking) {

            // We are going to change some titles if this is an agent booking
            $('.js-title-agent-1').text('Quote details for your customer:');
            $('.js-title-agent-2').text('Your customers rate');
            $('.js-title-agent-3').text('Book this deal now for your customer');

            // Hide the terms from the form
            $('.js-hide-for-agent').hide();
            $('.js-show-for-agent').show();
            $('#terms').removeAttr('required');
            $('.js-last-name-input').closest('.field').addClass('half');
            $('.js-email-input').closest('.field').addClass('half');
            $('[for="email"]').text('Customer\'s Email');

            // Hide the terms from the form
            $('[name=payment-amount]').removeAttr('required');

            // User interactions on clicking the payment portal payment button

            // Add a loading symbol on the submission of a form
            $('body').on('submit', 'form.quoteForm', (e) => {
                e.preventDefault();

                //  Don't send an email to the user as this is still just a quote
                //  Email options, 0=never send email, 1=default behaviour, 2=always send email
                let state = {
                    resservation_reference: booking.reservationref,
                    insurance_id: data.extrafees.find((fee) => fee.isinsurancefee).extrafeeid,
                    extra_kms_id: data.extrakmsid || 0,
                    email_option: 0,
                    remark: booking.remark,
                    number_travelling: booking.numbertravelling,
                    flight_in: booking.flightin,
                    flight_out: booking.flightout,
                    arrival_point: booking.arrivalpoint,
                    departure_point: booking.departurepoint,
                    // #referral_id: data.referralid,
                    // #area_of_use_id: data.areaofuseid,
                    // #newsletter: data.newsletter,
                    agent_code: $('.js-agent-code').val() || '',
                    // #agent_name: data.agentname,
                    agent_email: $('.js-agent-email-input').val(),
                    agent_ref_no: booking.agentrefno,
                    customer: {
                        first_name: $('.js-first-name-input').val(),
                        last_name: $('.js-last-name-input').val(),
                        email: $('.js-email-input').val()
                    },
                    optional_fees: data.extrafees.map((fee) => { if (!fee.isinsurancefee) return { id: fee.extrafeeid, qty: fee.qty } }).filter(item => { return item !== undefined; }),

                }

                // Make the request as a quote type booking
                api.convert_quote(state)
                    .then(json => {

                        // Remove the loading class to the button
                        $('.js-convert-quote-to-booking').removeClass('busy');

                        if (json.error !== '') {
                            //  Show any errors if there are any
                            error.showError(json.error);
                        } else {
                            // Send an email to the client on successful conversion
                            api.send_email({
                                reservation_number: booking.reservationref,
                                email_type_name: 'convertquote',
                                workflow_code: 'convertquote'
                            })
                                .then(json => {

                                    // Take the user to the sucess page
                                    window.location = `${window.location.origin}/response/?refID=${booking.reservationref}`

                                }).catch(error => {

                                    // Remove the loading class to the button
                                    $('.js-convert-quote-to-booking').removeClass('busy');

                                    // Show the error
                                    console.error(error);

                                    // Log any errors discretely
                                    log.error('API catch: send_email', error);

                                });
                        };



                    }).catch(error => {

                        // Remove the loading class to the button
                        $('.js-convert-quote-to-booking').removeClass('busy');

                        // Show the error
                        console.error(error);

                        // Log any errors discretely
                        log.error('API catch: convert_quote', error);

                    });


            });
        }

    }

};



/*------------------------------------------------------------------

                    QUOTE TO BOOKING PAGE

This is the entry point for the quote to booking form that allows
users to change their quoteations into bookings. The form will show 
and hide form elements depending on wether or not the booking is
a booking request (limited availability) or an actual available 
booking.
------------------------------------------------------------------*/

$(() => {

    // Find the reservation reference from the URL if there is one
    let url = new URL(window.location.href);
    let reservation_reference = url.searchParams.get('refID');
    let $quoteToBooking = $('.js-quote-to-booking');

    // Fetch a booking depending on if there is a URL parameter or not
    if ($quoteToBooking.length && reservation_reference) {

        // Show the vehicle loader
        $('body').addClass('loading');

        // Fetch the booking from the RCM API
        api.fetch_booking_post({ reservation_reference })
            .then(json => {
                (json.error === '') ? populateQuoteToBookingPage(json.results) : showBookingSearchForm(false, json.error);
            }).catch(error => {
                // Show the error
                console.error(error);

                // Log any errors discretely
                log.error('API catch: find_booking_post', error);

                // If there is an error show the booking search form
                showBookingSearchForm(false);
            });
    }

    // If no URL parameter is present, show the booking search form
    else if ($quoteToBooking.length) {
        showBookingSearchForm();
    }

    // Show and hide any sensitive data on the page
    $('body').on('click', '.js-toggle-sensitive-data', (e) => {
        $(e.currentTarget).toggleClass('visible');
    });

    // Add a loading symbol on the submission of a form
    $('body').on('submit', 'form.quoteForm', function () {
        $('.js-convert-quote-to-booking').addClass('busy');
    });

    // User interactions on the Swal popup
    $('body').on('keyup', '.js-last-name,.js-reservation-number', (e) => {
        // If a user hits the enter key, let's submit the form
        if (e.keyCode === 13) $('.swal2-confirm').trigger('click');
    });

    // Scroll tot eh quote to booking form on button click
    $('body').on('click', '.js-scroll-to-quote-form', (e) => {
        e.preventDefault();

        // Get the form element
        let $element = $('.js-quote-form');

        // Vanilla smooth scroll solution
        window.scroll({
            behavior: 'smooth',
            left: 0,
            top: $element[0].offsetTop - 90
        });
    });

});




/*------------------------------------------------------------------

                    CHECKIN PORTAL PAGE

This is the entry point for the checkin portal page that allows
users to update their booking details and checkin online. A user
can add extra drivers, update their payment details and sign for
the vehicle that they are going to be using.
------------------------------------------------------------------*/

$(() => {

    // Find the reservation reference from the URL if there is one
    let url = new URL(window.location.href);
    let reservation_reference = url.searchParams.get('refID');
    let $checkinPortal = $('.js-checkin-portal');

    // Fetch a booking depending on if there is a URL parameter or not
    if ($checkinPortal.length && reservation_reference) {

        // Show the vehicle loader
        $('body').addClass('loading');

        // Fetch the booking from the RCM API
        api.fetch_workflow_checklist({ reservation_reference })
            .then(json => {
                (json.error === '') ? populateCheckinPage(json.results) : showBookingSearchForm(false, json.error);
            }).catch(error => {
                // Show the error
                console.error(error);

                // Log any errors discretely
                log.error('API catch: fetch_workflow_checklist', error);

                // If there is an error show the booking search form
                showBookingSearchForm(false);
            });

    }

    // If no URL parameter is present, show the booking search form
    else if ($checkinPortal.length) {
        showBookingSearchForm();
    }

});
